export const TutorialPillsNotification = {
  if: true,
  state: {
    descr: 'Symbols unifies HTML, CSS, and JavaScript into a single JavaScript object, giving you full control over structure, style, and behavior with elegant, expressive code.',
    src: 'code-preview.gif',
    title: 'Enjoy coding!',
    key: 'symbolsCodeExplained',
    docsArticle: '/building-in-symbols',
  },
  Img: {},
  Hgroup: {},
  TutorialNotificationButtons: null,
  extends: 'TutorialGifNotification',
  theme: null,
  overflow: null,
};